// NPM
import React from "react";
import { useTranslation } from "react-i18next";
import { map, isEmpty } from "lodash";

// ANT COMPONENTS
import { Col, Row, Input, Radio, InputNumber, Divider } from "antd";

const InstructionComponent = () => {
  return (
    <Row>
      <Col>Instructions</Col>
      <Divider className="umo-divider" />
      <Col>
        <ol>
          <li>Download the mass order template.</li>
          <li>The "No" column must be unique for each individual and bulk order. </li>
          <li>
            Fill in each column. All columns are mandatory except <strong>Special Care</strong>,{" "}
            <strong>Special Condition</strong> and <strong>Tracking Number</strong>.
          </li>
          <li>
            The table below shows the various options for Delivery Type, Service Type, Special
            Condition, Special Care, and Type of Goods. Fill in as required in their respective
            columns.
          </li>
          <li>
            Specify <strong>TRUE</strong> or <strong>FALSE</strong> in the last column for insurance
            charge.
            <ol type="a">
              <li>TRUE: if insurance is required.</li>
              <li>FALSE: if insurance is not required.</li>
            </ol>
          </li>
          <li>
            For bulk order,
            <ol type="a">
              <li>
                The same bulk order is indicated when multiple orders have the same "No" field.
              </li>
              <li>
                All columns in the first row of a bulk order must be filled, with the exception of{" "}
                <strong>Special Care</strong>, <strong>Special Condition</strong> and{" "}
                <strong>Tracking Number</strong>
              </li>
              <li>
                Starting from the second row of the same bulk order, only columns of{" "}
                <strong>Type of Goods</strong>, <strong>Value</strong> and{" "}
                <strong>Insurance</strong> are required to be filled.
              </li>
              <li>Once completed, upload the template and create an order.</li>
            </ol>
          </li>
          <li>
            For split shipment,
            <ol type="a">
              <li>
                The same split shipment order is indicated when multiple orders have the same "Tracking No" field.
              </li>
              <li>
                A split shipment order must have the same{" "}
                <strong>Recipient Address</strong> and{" "}<strong>Sender Address</strong>.
              </li>
              <li>
                All columns are required to be filled.
              </li>
            </ol>
          </li>
        </ol>
      </Col>
    </Row>
  );
};

const TableOfTypes = ({ orderSettingsInfo }) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col span={24}>Table of Types</Col>
      <Divider className="umo-divider" />
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Row gutter={[0, 8]}>
              <Col span={24}>{t("label.specialCondition")}</Col>
              <Col span={24}>
                <ul>
                  {map(orderSettingsInfo?.orderSettingsInfo?.SPECIAL_CONDITION, (a, key) => {
                    return <li key={key}>{a.name}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <Row gutter={[0, 8]}>
              <Col span={24}>{t("label.specialCare")}</Col>
              <Col span={24}>
                <ul>
                  {map(orderSettingsInfo?.orderSettingsInfo?.SPECIAL_CARE, (a, key) => {
                    return <li key={key}>{a.name}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <Row gutter={[0, 8]}>
              <Col span={24}>{t("label.deliveryType")}</Col>
              <Col span={24}>
                <ul>
                  {map(orderSettingsInfo?.orderSettingsInfo?.DELIVERY_TYPE, (a, key) => {
                    return <li key={key}>{a.name}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <Row gutter={[0, 8]}>
              <Col span={24}>{t("label.serviceType")}</Col>
              <Col span={24}>
                <ul>
                  {map(orderSettingsInfo?.orderSettingsInfo?.SERVICE_TYPE, (a, key) => {
                    return <li key={key}>{a.name}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <Row gutter={[0, 8]}>
              <Col span={24}>{t("label.typeOfGoods")}</Col>
              <Col span={24}>
                <ul>
                  {map(orderSettingsInfo?.orderSettingsInfo?.TYPE_OF_GOODS, (a, key) => {
                    return <li key={key}>{a.name}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const MassOrderInfoDisplay = (orderSettingsInfo) => {
  const { t } = useTranslation();

  return (
    <Row className="upload-mass-order-modal">
      <Col span={24}>
        <div className="umo-title">
          <h3>{t("txt.massOrderTemplate")}</h3>
        </div>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <InstructionComponent />
          </Col>
          <Col span={24}>
            {!isEmpty(orderSettingsInfo) ? (
              <TableOfTypes orderSettingsInfo={orderSettingsInfo} />
            ) : (
              <Row>{t("txt.noInformation")}</Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default MassOrderInfoDisplay;
